import React from 'react';

const InstagramIcon: FCWithClassName = (props) => {
  return (
    <svg
      enableBackground="new 0 0 551.034 551.034"
      viewBox="0 0 551.034 551.034"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <linearGradient id="a">
        <stop offset="0" stopColor="#e09b3d" />
        <stop offset=".3" stopColor="#c74c4d" />
        <stop offset=".6" stopColor="#c21975" />
        <stop offset="1" stopColor="#7024c4" />
      </linearGradient>
      <linearGradient
        id="b"
        gradientTransform="matrix(1 0 0 -1 0 554)"
        gradientUnits="userSpaceOnUse"
        x1="275.517"
        x2="275.517"
        xlinkHref="#a"
        y1="4.57"
        y2="549.72"
      />
      <linearGradient
        id="c"
        gradientTransform="matrix(1 0 0 -1 0 554)"
        gradientUnits="userSpaceOnUse"
        x1="418.31"
        x2="418.31"
        xlinkHref="#a"
        y1="4.57"
        y2="549.72"
      />
      <path
        d="m386.878 0h-222.722c-90.516 0-164.156 73.64-164.156 164.156v222.722c0 90.516 73.64 164.156 164.156 164.156h222.722c90.516 0 164.156-73.64 164.156-164.156v-222.722c-.001-90.516-73.641-164.156-164.156-164.156zm108.722 386.878c0 60.045-48.677 108.722-108.722 108.722h-222.722c-60.045 0-108.722-48.677-108.722-108.722v-222.722c0-60.046 48.677-108.722 108.722-108.722h222.722c60.045 0 108.722 48.676 108.722 108.722z"
        fill="url(#b)"
      />
      <path
        d="m275.517 133c-78.584 0-142.517 63.933-142.517 142.516s63.933 142.517 142.517 142.517 142.517-63.933 142.517-142.517-63.933-142.516-142.517-142.516zm0 229.6c-48.095 0-87.083-38.988-87.083-87.083s38.989-87.083 87.083-87.083c48.095 0 87.083 38.988 87.083 87.083 0 48.094-38.989 87.083-87.083 87.083z"
        fill="url(#b)"
      />
      <circle cx="418.31" cy="134.07" fill="url(#c)" r="34.15" />
    </svg>
  );
};

export default InstagramIcon;
